import {
  Dialog,
  DialogTrigger,
  Modal,
  ModalOverlay,
  ModalOverlayProps,
} from "react-aria-components";
import { IButtonProps, Heading, Text } from "ui-components";

import { SocialLoginButton } from "../homepage/HeroSection";

export interface IQuickSignIn
  extends ModalOverlayProps,
    Pick<IButtonProps, "intent"> {}

export function QuickSignIn({ ...props }: IQuickSignIn): JSX.Element {
  return (
    <DialogTrigger>
      <ModalOverlay
        {...props}
        isDismissable
        className={({ isEntering, isExiting }) => `
          fixed  inset-0 z-10 overflow-y-auto bg-black/25 flex min-h-full items-center justify-center p-4 text-center backdrop-blur
          ${isEntering ? "animate-in fade-in duration-300 ease-out" : ""}
          ${isExiting ? "animate-out fade-out duration-200 ease-in" : ""}
        `}
      >
        <Modal
          className={({ isEntering, isExiting }) => `
            w-full  max-w-[40rem]  overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl
            ${isEntering ? "animate-in zoom-in-95 ease-out duration-300" : ""}
            ${isExiting ? "animate-out zoom-out-95 ease-in duration-200" : ""}
          `}
        >
          <Dialog role="alertdialog" className="outline-none relative ">
            {() => (
              <div className="flex flex-col gap-4  overflow-auto">
                <Heading>Quick Login</Heading>
                <Text variant="large">
                  Continue with linkedin to view the job
                </Text>
                <SocialLoginButton
                  type="linked-in"
                  buttonInitials="Log in with"
                />
              </div>
            )}
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  );
}
